import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { DynamicMapElementPropertiesEditorTemplate, LabelInput } from './DynamicMapElementPropertiesSharedElements';
import { sharedStore } from '../../stores/SharedStore';
export const DynamicMapElementAnimationElementPropertiesEditor = observer(({
  element,
  mapEditorStore
}) => {
  const {
    t
  } = useTranslation();
  const animation = sharedStore.getAnimationByName(element.animationName);
  return /*#__PURE__*/React.createElement(DynamicMapElementPropertiesEditorTemplate, {
    element: element,
    mapEditorStore: mapEditorStore,
    elementTypeKey:
    /*t*/
    "editor.editor_display_type_animation_element"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: element.isInteractionTrigger,
    onChange: () => element.setIsInteractionTrigger(!element.isInteractionTrigger)
  }), "\xA0", t("editor.element_is_interaction_trigger")))), element.isInteractionTrigger && !mapEditorStore.currentMapStore.isCurrentMapPartOfTheModule && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: element.isModuleGate,
    onChange: () => element.setIsModuleGate(!element.isModuleGate)
  }), "\xA0", t("editor.element_is_module_gate_interaction_trigger")))), /*#__PURE__*/React.createElement(LabelInput, {
    element: element,
    allElements: mapEditorStore.currentMapStore.currentMap.animationElements,
    alreadyUsedWarningLabelKey:
    /*t*/
    "editor.warning_animation_element_label_already_used",
    onChange: value => element.setLabel(value)
  }), animation && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.animation_element_start_animation"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("select", {
    value: element.startAnimationName,
    onChange: ({
      target
    }) => element.setStartAnimationName(target.value)
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), animation.animationNames.map(animationName => /*#__PURE__*/React.createElement("option", {
    key: animationName,
    value: animationName
  }, animationName))))), element.startAnimationName.length > 0 && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.animation_element_start_animation_loops"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: element.startAnimationLoops,
    onChange: () => element.setStartAnimationLoops(!element.startAnimationLoops)
  })))))));
});